export const getDimensions = async (rawFile) => await new Promise((resolve, reject) => {
    const imgUrl = URL.createObjectURL(rawFile);
    const img = new Image();
    let result = {};

    img.onload = () => {
        result = {
            width: img.width,
            height: img.height,
        };

        URL.revokeObjectURL(imgUrl);
        resolve(result);
    };

    img.onerror = () => {
        URL.revokeObjectURL(imgUrl);
        reject(new Error("Failed to load image"));
    };

    img.src = imgUrl;

    return result;
});